import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  user: null,
  access_token: null,
  refresh_token: null,
  role: null,
  isLoggedIn: false,
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    loginSuccess: (state, action) => {
      const { user, access_token, refresh_token, role } = action.payload;

      state.user = user;
      state.access_token = access_token;
      state.refresh_token = refresh_token;
      state.role = role || user?.user_type || user?.role;
      state.isLoggedIn = true;
    },

    logout: (state) => {
      state.user = null;
      state.access_token = null;
      state.refresh_token = null;
      state.role = null;
      state.isLoggedIn = false;
    },

    updateUser: (state, action) => {
      state.user = {
        ...state.user,
        ...action.payload,
      };
    },

    switchVendorType: (state, action) => {
      const vendorType = action.payload;

      state.role = vendorType;

      if (state.user) {
        state.user.vendor_type = vendorType;
      }
    },

    updateTokens: (state, action) => {
      if (action.payload.access_token) {
        state.access_token = action.payload.access_token;
      }

      if (action.payload.refresh_token) {
        state.refresh_token = action.payload.refresh_token;
      }
    },
  },
});

export const {
  loginSuccess,
  logout,
  updateUser,
  updateTokens,
  switchVendorType,
} = authSlice.actions;

export default authSlice.reducer;